/**
 * The columns and tile width that make the biggest tiles of a given shape fit everybody in
 * a box of this size - the way Google Meet lays out a call. Tiles never get taller than
 * they are wide for their shape, so a camera is never stretched to fill a leftover gap.
 */
export const fitTiles = (count, width, height, ratio, gap = 10, minWidth = 110) => {
    if (!count || !width || !height) return { columns: Math.max(1, Math.min(count, 4)), tile: 0 };
    let best = { columns: 1, tile: 0 };
    for (let columns = 1; columns <= count; columns += 1) {
        const rows = Math.ceil(count / columns);
        const byWidth = (width - gap * (columns - 1)) / columns;
        const byHeight = ((height - gap * (rows - 1)) / rows) * ratio;
        const tile = Math.floor(Math.min(byWidth, byHeight));
        if (tile > best.tile) best = { columns, tile };
    }
    // Too many people to fit at a readable size: keep that size and let the box scroll.
    if (best.tile < minWidth) {
        const columns = Math.max(1, Math.min(count, Math.floor((width + gap) / (minWidth + gap))));
        return { columns, tile: Math.floor((width - gap * (columns - 1)) / columns) };
    }
    return best;
};
